// extracted by mini-css-extract-plugin
module.exports = {"tasksDashboard":"TasksTab_tasksDashboard__yyGqw"};